import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";


import {
  getAuth, 
} from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyD3j70qKzHVUciuTj1kynXJl1xdwWGrOCg",
  authDomain: "myhussainfinal.firebaseapp.com",
  projectId: "myhussainfinal",
  storageBucket: "myhussainfinal.appspot.com",
  messagingSenderId: "494988916780",
  appId: "1:494988916780:web:596718ca005245c395b989",
  measurementId: "G-VR4Z2RT4BE"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

const authweb = getAuth(app);

const db = getFirestore();
export {  db ,authweb};


export const fetchToken = (setTokenFound) => {
  return getToken(messaging, {vapidKey:'BGYVU2_d6Ir8tYyefuFM3yx2zT-Ix0HGiihbWPWKH18LzJUOfccqjHSDWemeUolcfhI1scmB6gtD0dTqp57YXhs'}).then((currentToken) => {
    if (currentToken) {
      console.log('current token for client: ', currentToken);
      setTokenFound(currentToken);
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      console.log('No registration token available. Request permission to generate one.');
      setTokenFound(false);
      // shows on the UI that permission is required 
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
    // catch error while creating client token
  });
}

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});
